export default {
  s02bX: 0,
  cashBook: 1, // Báo cáo không có đối tượng ( Mẫu ngang )
  cashBookObject: 2, // Báo cáo có đối tượng
};
